import React from 'react';
import PropTypes from 'prop-types';
import './SurveySummary.css';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  display: 'flex',
  flexDirection: 'column'
}));

const SurveySummary = props => {
  let i = -1;
  return (
    <div
      id="surveySummary"
      style={{
        display: 'flex',
        justiyContent: 'space-between',
        flexDirection: 'column'
      }}
    >
      <div id="pageTitle">
        <p className="surveyHeading fs-unmask">REVIEW & SUBMIT</p>
        <hr className="hr" />
      </div>
      <div id="sectionHeading" className="sectionHeading">
        <p className="sectionHeadingText fs-unmask">
          {props.contactAttributes.typeId === 'Chat'
            ? 'CHAT INFORMATION'
            : props.contactAttributes.typeId === 'Task'
            ? 'TASK INFORMATION'
            : 'CALL INFORMATION'}
        </p>
        <FontAwesomeIcon
          icon={faPenToSquare}
          className="penToSquare"
          onClick={() => props.setStep(1)}
        />
      </div>
      <Box
        id="callInfoBox"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          border: 2,
          borderColor: 'divider',
          borderRadius: '4px',
          marginBottom: '10px',
          marginLeft: '20px',
          width: '92%'
        }}
      >
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          sx={{ m: 3, paddingLeft: '20px' }}
        >
          <Grid item xs={6}>
            <Item>
              <span id="itemHeading" className="itemHeading fs-unmask">
                Agent&apos;s First Name
              </span>
              <span id="itemValue" className="itemValue fs-unmask">
                {props.generalDetails.firstName}
              </span>
            </Item>
          </Grid>
          <Grid item xs={6}>
            <Item>
              <span id="itemHeading" className="itemHeading fs-unmask">
                Agent&apos;s Last Name
              </span>
              <span id="itemValue" className="itemValue fs-unmask">
                {props.generalDetails.lastName}
              </span>
            </Item>
          </Grid>
          <Grid item xs={6}>
            <Item>
              <span id="itemHeading" className="itemHeading fs-unmask">
                Agent&apos;s Email
              </span>
              <span id="itemValue" className="itemValue fs-unmask">
                {props.generalDetails.email}
              </span>
            </Item>
          </Grid>
          <Grid item xs={6}>
            <Item>
              <span id="itemHeading" className="itemHeading fs-unmask">
                Language
              </span>
              <span id="itemValue" className="itemValue fs-unmask">
                {props.generalDetails.language}
              </span>
            </Item>
          </Grid>
          <Grid item xs={6}>
            <Item>
              <span id="itemHeading" className="itemHeading fs-unmask">
                Request Type
              </span>
              <span id="itemValue" className="itemValue fs-unmask">
                {props.generalDetails.requestType}
              </span>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item>
              <span id="itemHeading" className="itemHeading fs-unmask">
                Caller Type
              </span>
              <span id="itemValue" className="itemValue fs-unmask">
                {props.generalDetails.callerType}
              </span>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item>
              <span id="itemHeading" className="itemHeading fs-unmask">
                Claim ID
              </span>
              <span id="itemValue" className="itemValue fs-unmask">
                {props.generalDetails.claim !== ''
                  ? props.generalDetails.claim
                  : props.generalDetails.claimOther}
              </span>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item>
              <span id="itemHeading" className="itemHeading fs-unmask">
                Work Item Type
              </span>
              <span id="itemValue" className="itemValue fs-unmask">
                {props.generalDetails.workItemType}
              </span>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item>
              <span id="itemHeading" className="itemHeading fs-unmask">
                First time contacting Unum regarding issue?
              </span>
              <span id="itemValue" className="itemValue fs-unmask">
                {props.generalDetails.firstTimeIssue}
              </span>
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item>
              <span id="itemHeading" className="itemHeading fs-unmask">
                Did they receive initial liability decision?
              </span>
              <span id="itemValue" className="itemValue fs-unmask">
                {props.generalDetails.liabilityDecisionReceived}
              </span>
            </Item>
          </Grid>
          {/* If callback task, print callback task details */}
          {props.contactAttributes.typeId === 'Task' &&
          props.contactAttributes.callReason &&
          props.contactAttributes.callReason.value !== '' ? (
            <div id="task-details" style={{ paddingLeft: '20px' }}>
              <Grid item xs={12}>
                <Item>
                  <span id="itemHeading" className="itemHeading fs-unmask">
                    Was employee successfully reached?
                  </span>
                  <span id="itemValue" className="itemValue fs-unmask">
                    {props.taskDetails.successfullyReached}
                  </span>
                </Item>
              </Grid>
              <Grid item xs={12}>
                <Item>
                  <span id="itemHeading" className="itemHeading fs-unmask">
                    Callback Phone Number
                  </span>
                  <span id="itemValue" className="itemValue fs-unmask">
                    {props.taskDetails.callBackNumber}
                  </span>
                </Item>
              </Grid>
              <Grid item xs={12}>
                <Item>
                  <span id="itemHeading" className="itemHeading fs-unmask">
                    Callback Topic
                  </span>
                  <span id="itemValue" className="itemValue fs-unmask">
                    {props.taskDetails.callBackTopic}
                  </span>
                </Item>
              </Grid>
            </div>
          ) : null}
        </Grid>
        {/* </div> */}
      </Box>

      <div id="sectionHeading" className="sectionHeading">
        <p className="sectionHeadingText fs-unmask">
          {props.contactAttributes.typeId === 'Chat'
            ? 'PRIMARY CHAT REASONS'
            : props.contactAttributes.typeId === 'Task'
            ? 'PRIMARY TASK REASONS'
            : 'PRIMARY CALL REASONS'}
        </p>
        <FontAwesomeIcon
          icon={faPenToSquare}
          className="penToSquare"
          onClick={() => props.setStep(2)}
        />
      </div>
      <Box
        id="primaryCallReasonBox"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          border: 2,
          borderColor: 'divider',
          borderRadius: '4px',
          marginBottom: '10px',
          marginLeft: '20px',
          width: '92%'
        }}
      >
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          sx={{ m: 3, paddingLeft: '20px' }}
        >
          <Grid item xs={12}>
            <Item>
              <span id="primaryReasonHeading" className="primaryReasonHeading fs-unmask">
                PRIMARY REASON
              </span>
              <span id="primaryReasonValue" className="primaryReasonValue fs-unmask">
                {props.primaryCallReason.toLowerCase().includes('other')
                ? props.primaryCallReason + ' - ' + props.notes
                : props.primaryCallReason}
              </span>
            </Item>
          </Grid>
        </Grid>
      </Box>
      {props.callReasons != ''
        ?<div id="sectionHeading" className="sectionHeading">
        <p className="sectionHeadingText fs-unmask">
          {props.contactAttributes.typeId === 'Chat'
              ? 'ADDITIONAL CHAT REASON(S)'
              : props.contactAttributes.typeId === 'Task'
              ? 'ADDITIONAL TASK REASON(S)'
              : 'ADDITIONAL CALL REASON(S)'}
        </p>
        </div>
        :null}
      {props.callReasons.map(callReason => {
        i = i + 1;
        if (callReason !== props.primaryCallReason) {
          return (
            <Box
              id="callReasonBox"
              key={callReason}
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{
                border: 2,
                borderColor: 'divider',
                borderRadius: '4px',
                marginBottom: '10px',
                marginLeft: '20px',
                width: '92%'
              }}
            >
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                sx={{ m: 3, paddingLeft: '20px' }}
              >
                <Grid item xs={12}>
                  <Item>
                  <span id="primaryReasonHeading" className="primaryReasonHeading fs-unmask">
                    ADDITIONAL REASON(S)
                  </span>
                    <span id="callReasonHeading" className="callReasonHeading fs-unmask for">
                      {callReason.substring(6,).toLowerCase().includes('other') 
                        ? callReason.substring(6, ) + ' - ' + props.addNotesList[props.addNotesList.findIndex(element => element.includes(`${callReason.substring(0,6)}`))].substring(6,)
                        : callReason.substring(6,)
                      }
                    </span>
                  </Item>
                </Grid>
              </Grid>
            </Box>
          );
        }
      })}

      {props.callReasons.includes('Other') ? (
        <Box
          id="noteBox"
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            border: 2,
            borderColor: 'divider',
            borderRadius: '4px',
            marginBottom: '10px',
            marginLeft: '20px',
            width: '92%'
          }}
        >
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            sx={{ m: 3, paddingLeft: '20px' }}
          >
            <Grid item xs={12}>
              <Item>
                <span id="callReasonHeading" className="callReasonHeading fs-unmask">
                  Your Note
                </span>
                <span id="reasonSubValue" className="reasonSubValue fs-unmask">
                  {props.note}
                </span>
              </Item>
            </Grid>
          </Grid>
        </Box>
      ) : null}
      {props.additionalDetails != ''
       ?<div id="sectionHeading" className="sectionHeading">
        <p className="sectionHeadingText fs-unmask">
          ADDITIONAL DETAILS
        </p>
        <FontAwesomeIcon
          icon={faPenToSquare}
          className="penToSquare"
          onClick={() => props.setStep(3)}
        />
      </div>
      :null}
      {props.additionalDetails != '' ? (
        <Box
          id="additionalDetailsBox"
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            border: 2,
            borderColor: 'divider',
            borderRadius: '4px',
            marginBottom: '10px',
            marginLeft: '20px',
            width: '92%'
          }}
        >
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            sx={{ m: 3, paddingLeft: '20px' }}
          >
            <Grid item xs={12}>
              <Item>
                <span id="reasonSubValue" className="reasonSubValue fs-unmask">
                  {props.additionalDetails}
                </span>
              </Item>
            </Grid>
          </Grid>
        </Box>
        ) : null}
      <div
        id="buttonContainer"
        style={{ background: 'white' }}
        className="buttonContainer"
      >
        <hr className="hr" />
        <Stack spacing={2} direction="row">
          <Button
            id="backButton"
            variant="outlined"
            style={{
              borderRadius: '20px',
              opacity: 1,
              marginBottom: '10px',
              width: '40%',
              left: '10%'
            }}
            onClick={props.summaryBack}
            className="fs-unmask"
          >
            Back
          </Button>
          <Button
            id="nextButton"
            variant="contained"
            style={{
              background: '#127CB7',
              borderRadius: '20px',
              opacity: 1,
              marginBottom: '10px',
              width: '40%',
              left: '10%'
            }}
            onClick={props.submit}
            className="fs-unmask"
          >
            Submit
          </Button>
        </Stack>
      </div>
    </div>
  );
};

SurveySummary.propTypes = {
  contactAttributes: PropTypes.shape({
    typeId: PropTypes.string,
    callReason: PropTypes.shape({
      value: PropTypes.string,
    }),
  }).isRequired,
  generalDetails: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    language: PropTypes.string,
    requestType: PropTypes.string,
    callerType: PropTypes.string,
    claim: PropTypes.string,
    claimOther: PropTypes.string,
    workItemType: PropTypes.string,
    firstTimeIssue: PropTypes.string,
    liabilityDecisionReceived: PropTypes.string,
  }).isRequired,
  taskDetails: PropTypes.shape({
    successfullyReached: PropTypes.string,
    callBackNumber: PropTypes.string,
    callBackTopic: PropTypes.string,
  }),
  primaryCallReason: PropTypes.string.isRequired,
  callReasons: PropTypes.arrayOf(PropTypes.string).isRequired,
  note: PropTypes.string,
  notes: PropTypes.string,
  addNotesList: PropTypes.arrayOf(PropTypes.string),
  additionalDetails: PropTypes.string,
  setStep: PropTypes.func.isRequired,
  summaryBack: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
};

export default SurveySummary;
